import styled from 'styled-components/macro';

export const InfoBarItem = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 40px;
  border-right: solid 1px;
  &:last-child {
    border: none;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding: 10px 20px;
    border: none;
    text-align: center;
  }
`;
export const PlayerInfoBar = styled.div`
  display: flex;
  padding: 20px;
  background-color: ${props =>
    props.competition === 1 ? props.theme.coral : props.theme.turquoise};
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    flex-wrap: wrap;
    padding: 0px;
    justify-content: space-around;
  }
`;
export const InfoBarItemLabel = styled.div`
  font-size: 11px;
  color: ${props => props.theme.white};
`;
export const InfoBarItemValue = styled.div`
  font-size: 14px;
  font-weight: bold;
  margin-top: 12px;
  color: ${props => (props.isLocal ? props.theme.white : props.theme.dark)};
`;
